export default __webpack_public_path__ + "static/ug-ee8f3bacb5ed05779d6785682c9ebd14.svg";